<template>
  <div
    class="d-flex ms-2 me-2"
    style="width: 100%; height: calc(100% - 8.125rem); position: absolute"
  >
    <!-- 左侧设备列表 -->
    <div
      class="d-flex flex-wrap justify-content-between align-content-start scroll-container scroll-box"
      style="width: 60%; height: 100%; overflow: auto; padding: 0 20px"
    >
      <div
        v-for="(a, i) in instanceList"
        :key="a.id"
        style="
          width: 48%;
          height: 380px;
          min-width: 460px;
          border-radius: 20px;
          border: 2px solid rgba(198, 194, 194, 0.2);
          background: #1e2130;
        "
        id="reverse"
        class="box mb-3 p-4"
      >
        <Top_title_statistics
          class="cursor-pointer"
          @changeReverse="changeReverse"
          :name="
            !a.isRolling
              ? a.name
              : a.children && a.children[a.eIndex] && a.children[a.eIndex].name
          "
          :snNum="
            !a.isRolling
              ? a.sn
              : a.children && a.children[a.eIndex] && a.children[a.eIndex].sn
          "
          :snData="a"
          :snIndex="i"
          :show-button="false"
        ></Top_title_statistics>
        <div v-if="!a.isRolling" class="w-100 h-100 position-relative">
          <img
            v-if="a.children"
            class="position-absolute"
            style="
              width: 60%;
              top: 1rem;
              left: 1rem;
              cursor: pointer;
              height: 70%;
            "
            :src="a.files.image[0] && a.files.image[0].url"
            @click="toPath(a.model, a.id, i, a)"
            alt=""
          />
          <img
            v-else
            class="position-absolute"
            style="
              width: 60%;
              top: 1rem;
              left: 1rem;
              cursor: pointer;
              height: 70%;
            "
            :src="a.files.image[0] && a.files.image[0].url"
            @click="toPath(a.model, a.id, i, a)"
            alt=""
          />
          <div class="w-100 d-flex" style="height: 95%">
            <div style="width: 70%; height: 100%"></div>
            <div style="width: 30%; height: 100%">
              <div class="fs-16 mt-4" style="font-weight: 600">
                {{ $t("overview_static.customer_page.status") }}
              </div>
              <div
                class="fs-15 d-flex align-items-center"
                :style="{
                  fontWeight: '400',
                  color: a.is_iot_ready ? getStatObj(a.stat).color : '#b6b7bc',
                }"
              >
                <!-- <img
                  style="width: 1.875rem; height: 1.875rem"
                  :src="
                    a.is_iot_ready
                      ? require('@/assets/images/statistics/normal.svg')
                      : require('@/assets/images/statistics/info.svg')
                  "
                  alt=""
                />
                <img
                    style="width: 1.875rem; height: 1.875rem"
                    src="@/assets/images/statistics/normal.svg"
                    alt=""
                /> -->
                <!-- <img v-if="a.is_iot_ready" style="width: 1.875rem; height: 1.875rem"
                  :src=" getStatObj(a.stat).img" alt="" />
                  <img v-else style="width: 1.5rem; height: 1.5rem" src="@/assets/images/statistics/info.svg" alt="" /> -->

                <!-- IOT数据升级，以及该接通IOT后设备健康 -->
                <!-- 健康,异常,危险 -->

                <span
                  v-if="a.is_iot_ready"
                  :class="`status-icon status-icon-${getStatObj(a.stat).icon}`"
                  style="
                    padding: 8px 15px;
                    width: 25px;
                    height: 25px;
                    background-size: 25px 25px;
                  "
                ></span>
                <!-- 请进行IoT升级 -->
                <img
                  v-else
                  style="width: 1.5rem; height: 1.5rem"
                  src="@/assets/images/statistics/info.svg"
                  alt=""
                />
                <div>
                  {{
                    a.is_iot_ready
                      ? a.stat !== undefined &&
                        a.stat !== null &&
                        getStatObj(a.stat).name
                      : $t('overview_dynamic["请进行IoT升级"]')
                  }}
                </div>
              </div>
              <div
                v-if="a.children"
                @click="changeReverse(i, a)"
                class="fs-20 bold text-decoration-underline cursor-pointer"
                style="word-wrap: break-word"
              >
                {{ $t("page.ViewingAssociatedDevices") }}
              </div>
              <div v-else style="width: 100%">
                <div
                  class="fs-16 mt-2"
                  style="font-weight: 600; color: #ffffff"
                >
                  {{ $t("overview_static.customer_page.service_status") }}
                </div>
                <div class="fs-16" style="font-weight: 400; color: #b6b7bc">
                  {{ $t("overview_static.customer_page.next_service_time") }}
                </div>
                <div class="fs-16" style="font-weight: 500; color: #00e7ff">
                  {{ a.next_maintenance_time }}
                </div>
                <div
                  v-show="a.delay_day < 0"
                  class="fs-14"
                  style="font-weight: 400; color: #f77474"
                >
                  {{ $t("overview_static.customer_page.delayed") }}
                  {{ Math.abs(Number(a.delay_day)) }}
                  {{ $t('overview_static.customer_page["天"]') }}
                </div>
                <div class="fs-16" style="font-weight: 400; color: #b6b7bc">
                  {{ $t("overview_static.customer_page.next_service") }}
                </div>
                <div class="fs-16" style="font-weight: 500; color: #00e7ff">
                  {{
                    !a.next_maintenance_item || a.next_maintenance_item == "-"
                      ? "-"
                      : [
                          $t('overview_dynamic.service_type_dict["一级保养"]'),
                          $t('overview_dynamic.service_type_dict["二级保养"]'),
                          $t('overview_dynamic.service_type_dict["返厂大修"]'),
                        ][Number(a.next_maintenance_item) - 1]
                  }}
                </div>
              </div>
            </div>
          </div>
          <div
            style="width: 100%; position: absolute; bottom: 40px; left: 0"
            class="d-flex justify-content-between align-items-end"
          >
            <div
              style="
                border-radius: 5px;
                background: #11cabe;
                line-height: 1.5rem;
                padding: 0 0.3125rem;
              "
              :style="{
                background:
                  a.warranty_status === '在保' || a.warranty_status === true
                    ? '#11cabe'
                    : '#F77474',
              }"
            >
              {{
                a.warranty_expiration_time &&
                a.warranty_expiration_time.length > 0
                  ? a.warranty_status === "在保" || a.warranty_status === true
                    ? $t('overview_dynamic["在保"]')
                    : $t('overview_dynamic["脱保"]')
                  : ""
              }}
            </div>
            <div style="font-weight: 600">
              {{ $t("overview_static.customer_page.warranty_valid_until") }}
            </div>
            <div style="font-weight: 600">
              {{ a.warranty_expiration_time }}
            </div>
            <div
              style="
                font-weight: 600;
                text-decoration: underline;
                cursor: pointer;
              "
              class="d-flex"
            >
              <div
                @click="
                  $router.push(
                    '/repair-request/add?id=' + costumerId + '&sn=' + a.sn
                  )
                "
              >
                {{ $t("service_request") }}
              </div>
            </div>
            <div>
              <el-tooltip
                popper-class="packageDownLoad-tooltip"
                class="box-item"
                effect="dark"
                placement="top-end"
              >
                <template #content>
                  <div style="width: 180px; font-size: 13px">
                    {{
                      $t(
                        "佶缔纳士是您值得信赖的合作伙伴,了解我们的CARE服务,让您的设备保持高效稳定的运行,为您的生产经营保驾护航！"
                      )
                    }}
                  </div>
                </template>

                <img
                  class="ms-2"
                  style="width: 50px; height: 50px"
                  src="../../assets/vsd420/care.svg"
                  alt="#"
                />
              </el-tooltip>
            </div>
          </div>
        </div>
        <div v-if="a.isRolling" class="w-100 h-100 d-flex position-relative">
          <div
            style="width: 100%; position: absolute; bottom: 40px; left: 0"
            class="d-flex justify-content-between align-items-end"
          >
            <div
              style="
                border-radius: 5px;
                background: #11cabe;
                line-height: 1.5rem;
                padding: 0 0.3125rem;
              "
              :style="{
                background:
                  a.children &&
                  a.children[a.eIndex] &&
                  (a.children[a.eIndex].warranty_status == '在保' ||
                    a.children[a.eIndex].warranty_status === true)
                    ? '#11cabe'
                    : '#F77474',
              }"
            >
              {{
                a.children &&
                a.children[a.eIndex] &&
                a.children[a.eIndex].warranty_expiration_time &&
                a.children[a.eIndex].warranty_expiration_time.length > 0
                  ? a.children &&
                    a.children[a.eIndex] &&
                    (a.children[a.eIndex].warranty_status == "在保" ||
                      a.children[a.eIndex].warranty_status === true)
                    ? $t('overview_dynamic["在保"]')
                    : $t('overview_dynamic["脱保"]')
                  : ""
              }}
            </div>
            <div style="font-weight: 600">
              {{ $t("overview_static.customer_page.warranty_valid_until") }}
            </div>
            <div style="font-weight: 600">
              {{
                a.children &&
                a.children[a.eIndex] &&
                a.children[a.eIndex].warranty_expiration_time
              }}
            </div>
            <div
              style="
                font-weight: 600;
                text-decoration: underline;
                cursor: pointer;
              "
              class="d-flex"
            >
              <div
                @click="
                  $router.push(
                    '/repair-request/add?id=' +
                      costumerId +
                      '&sn=' +
                      a.children[a.eIndex].sn
                  )
                "
              >
                {{ $t("service_request") }}
              </div>
            </div>
            <div>
              <el-tooltip
                popper-class="packageDownLoad-tooltip"
                class="box-item"
                effect="dark"
                placement="top-end"
              >
                <template #content>
                  <div style="width: 180px; font-size: 13px">
                    佶缔纳士是您值得信赖的合作伙伴,了解我们的CARE服务,让您的设备保持高效稳定的运行,为您的生产经营保驾护航！
                  </div>
                </template>
                <img
                  class="ms-2"
                  style="width: 50px; height: 50px"
                  src="../../assets/vsd420/care.svg"
                  alt="#"
                />
              </el-tooltip>
            </div>
          </div>
          <div
            style="width: 70%; height: 95%"
            class="d-flex flex-wrap align-content-start position-relative"
          >
            <div
              class="w-100 mt-3 d-flex justify-content-between align-items-center align-content-center"
            >
              <i
                @click="eIndexChange(i, '2')"
                class="fs-24 ri-arrow-left-s-line"
              ></i>
              <img
                style="width: 50%;height: 170px;"
                class="cursor-pointer"
                @click="
                  toPath(
                    a.model, a.id, i, a,
                    a.children[a.eIndex].id,
                  )
                "
                :src="
                  a.children &&
                  a.children[a.eIndex] &&
                  a.children[a.eIndex].files.image[0] &&
                  a.children[a.eIndex].files.image[0].url
                "
                alt=""
              />
              <i
                @click="eIndexChange(i, '1')"
                class="fs-24 ri-arrow-right-s-line"
              ></i>
            </div>
            <div
              style="overflow-x: auto"
              class="ms-2 mt-2 me-2 w-100 d-flex justify-content-center"
            >
              <div
                v-for="(b, index) in a.children"
                :key="b.id"
                class="me-2 d-flex justify-content-center align-items-center cursor-pointer"
                style="
                  width: 3.75rem;
                  height: 3.75rem;
                  border-radius: 5px;
                  border: 1px solid #fff;
                "
                :style="{
                  background:
                    a.eIndex == index
                      ? ' rgba(116, 116, 116, 0)'
                      : 'rgba(116, 116, 116, 0.60)',
                }"
              >
                <img
                  style="width: 80%; height: 60%"
                  @click="imgChange(i, index)"
                  :src="b.files.image[0] && b.files.image[0].url"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div style="width: 30%; height: 95%">
            <div class="fs-16 mt-4" style="font-weight: 600">
              {{ $t("overview_static.customer_page.status") }}
            </div>
            <div
              class="fs-15 d-flex align-items-center"
              :style="{
                fontWeight: '400',
                color:
                  a.children &&
                  a.children[a.eIndex] &&
                  a.children[a.eIndex].is_iot_ready
                    ? a.children &&
                      a.children[a.eIndex] &&
                      getStatObj(a.children[a.eIndex].stat).color
                    : '#b6b7bc',
              }"
            >
              <!--<img
                style="width: 1.875rem; height: 1.875rem"
                :src="
                  a.children&& a.children[a.eIndex] && a.children[a.eIndex].is_iot_ready
                    ? require('@/assets/images/statistics/normal.svg')
                    : require('@/assets/images/statistics/info.svg')
                "
                alt=""
              />
              <img
                  style="width: 1.875rem; height: 1.875rem"
                  src="@/assets/images/statistics/normal.svg"
                  alt=""
              />
              <div style="color:#11cabe">
                {{
                  a.children&& a.children[a.eIndex] && a.children[a.eIndex].is_iot_ready
                      ? $t("overview_static.customer_page.healthy")
                      : $t('overview_dynamic["请进行IoT升级"]')
                }}

                </div>-->
              <!-- <img v-if="a.children && a.children[a.eIndex] && a.children[a.eIndex].is_iot_ready"
                  style="width: 1.875rem; height: 1.875rem"
                  :src="a.children && a.children[a.eIndex] && getStatObj(a.children[a.eIndex].stat).img"
                  alt="" /> -->
              <!-- IOT数据升级，以及该接通IOT后设备健康 -->
              <!-- 健康,异常,危险 -->
              <span
                v-if="
                  a.children &&
                  a.children[a.eIndex] &&
                  a.children[a.eIndex].is_iot_ready
                "
                :class="`status-icon status-icon-${
                  a.children &&
                  a.children[a.eIndex] &&
                  a.children[a.eIndex].stat !== undefined &&
                  a.children[a.eIndex].stat !== null &&
                  getStatObj(a.children[a.eIndex].stat).icon
                }`"
                style="
                  padding: 8px 15px;
                  width: 25px;
                  height: 25px;
                  background-size: 25px 25px;
                "
              ></span>

              <!-- 请进行IoT升级 -->
              <img
                v-else
                style="width: 1.5rem; height: 1.5rem"
                src="@/assets/images/statistics/info.svg"
                alt=""
              />
              <div>
                {{
                  a.children &&
                  a.children[a.eIndex] &&
                  a.children[a.eIndex].is_iot_ready
                    ? a.children &&
                      a.children[a.eIndex] &&
                      getStatObj(a.children[a.eIndex].stat).name
                    : $t('overview_dynamic["请进行IoT升级"]')
                }}
              </div>
            </div>
            <div class="fs-16 mt-2" style="font-weight: 600; color: #ffffff">
              {{ $t("overview_static.customer_page.service_status") }}
            </div>
            <div class="fs-16" style="font-weight: 400; color: #b6b7bc">
              {{ $t("overview_static.customer_page.next_service_time") }}
            </div>
            <div class="fs-16" style="font-weight: 500; color: #00e7ff">
              {{
                a.children &&
                a.children[a.eIndex] &&
                a.children[a.eIndex].next_maintenance_time
              }}
            </div>
            <div
              v-show="
                a.children &&
                a.children[a.eIndex] &&
                a.children[a.eIndex].delay_day < 0
              "
              class="fs-14"
              style="font-weight: 400; color: #f77474"
            >
              {{ $t("overview_static.customer_page.delayed") }}
              {{
                Math.abs(
                  Number(
                    a.children &&
                      a.children[a.eIndex] &&
                      a.children[a.eIndex].delay_day
                  )
                )
              }}
              {{ $t('overview_static.customer_page["天"]') }}
            </div>
            <div class="fs-16" style="font-weight: 400; color: #b6b7bc">
              {{ $t("overview_static.customer_page.next_service") }}
            </div>

            <div class="fs-16" style="font-weight: 500; color: #00e7ff">
              {{
                [
                  $t('overview_dynamic.service_type_dict["一级保养"]'),
                  $t('overview_dynamic.service_type_dict["二级保养"]'),
                  $t('overview_dynamic.service_type_dict["返厂大修"]'),
                ][
                  Number(
                    a.children &&
                      a.children[a.eIndex] &&
                      a.children[a.eIndex].next_maintenance_item
                  ) - 1
                ]
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 右侧设备状态 -->
    <div style="width: 40%; height: 100%" class="d-flex flex-wrap">
      <div
        class="w-100 d-flex justify-content-around"
        style="height: 20%; min-height: 200px"
      >
        <div
          style="width: 90%; height: 100%"
          class="d-flex justify-content-between"
        >
          <div
            style="
              width: 48%;
              height: 100%;
              min-height: 150px;
              border-radius: 20px;
              border: 2px solid rgba(198, 194, 194, 0.2);
              background: #1e2130;
            "
            class="mb-3 p-4 position-relative"
          >
            <Top
              :name="$t('overview_static.customer_page.iot_status')"
              :show-button="false"
            ></Top>
            <div
              class="w-100 d-flex justify-content-between align-items-center"
            >
              <div
                class="fs-14 d-flex align-items-center justify-content-between"
                style="font-weight: 600; color: #11cabe; width: 40%"
              >
                <img
                  style="width: 2.15rem; height: 2.15rem"
                  src="@/assets/images/statistics/normal.svg"
                  alt=""
                />
                <div>{{ $t("overview_static.customer_page.online") }}</div>
              </div>
              <!--  在线设备数量 -->
              <div
                class="fs-14"
                style="font-weight: 600; width: 30%; line-height: 30px"
              >
                {{ online_num }}
              </div>
            </div>
            <div
              class="w-100 d-flex justify-content-between align-items-center"
              style="margin-top: -5px"
            >
              <div
                class="fs-14 d-flex align-items-center justify-content-between"
                style="font-weight: 600; color: #f77474; width: 40%"
              >
                <img
                  style="width: 2.15rem; height: 2.15rem"
                  src="@/assets/images/statistics/error.svg"
                  alt=""
                />
                <div>{{ $t('overview_dynamic["离线"]') }}</div>
              </div>
              <!--  离线设备数量 -->
              <div
                class="fs-14"
                style="font-weight: 600; width: 30%; line-height: 30px"
              >
                {{ offline_num }}
              </div>
            </div>
          </div>
          <div
            style="
              width: 48%;
              height: 100%;
              min-height: 150px;
              border-radius: 20px;
              border: 2px solid rgba(198, 194, 194, 0.2);
              background: #1e2130;
            "
            class="mb-3 p-4 position-relative"
          >
            <Top
              :name="$t('overview_static.customer_page.health_status')"
              :show-button="false"
            ></Top>
            <div
              class="scroll-box"
              style="height: calc(100% - 13px); overflow: auto"
            >
              <!--  健康 -->
              <div
                class="w-100 d-flex justify-content-between align-items-center"
              >
                <div
                  class="fs-14 d-flex align-items-center justify-content-between"
                  style="font-weight: 600; color: #11cabe; width: 40%"
                >
                  <!-- <img style="width: 1.875rem; height: 1.875rem" src="@/assets/images/statistics/normal.svg" alt="" /> -->
                  <span
                    class="status-icon mt-1 status-icon-health"
                    style="
                      padding: 8px 15px;
                      width: 25px;
                      height: 25px;
                      background-size: 25px 25px;
                    "
                  ></span>
                  <div>
                    {{ $t("overview_static.customer_page.healthy") }}
                  </div>
                </div>
                <div
                  class="fs-14"
                  style="font-weight: 600; line-height: 30px; width: 30%"
                >
                  {{ healthy_num }}
                </div>
              </div>
              <!--  异常 -->
              <div
                class="w-100 d-flex justify-content-between align-items-center"
              >
                <div
                  class="fs-14 d-flex align-items-center justify-content-between"
                  style="font-weight: 600; color: #faad14; width: 40%"
                >
                  <!-- <img style="width: 1.875rem; height: 1.875rem" src="@/assets/images/statistics/warn.svg" alt="" /> -->
                  <span
                    class="status-icon mt-1 status-icon-sub-health"
                    style="
                      padding: 8px 15px;
                      width: 25px;
                      height: 25px;
                      background-size: 25px 25px;
                    "
                  ></span>
                  <div>
                    {{ $t("overview_static.customer_page.abnormal") }}
                  </div>
                </div>
                <div class="fs-14" style="font-weight: 600; width: 30%">
                  {{ abnormal_num }}
                </div>
              </div>
              <!--  危险 -->
              <div
                class="w-100 d-flex justify-content-between align-items-center"
              >
                <div
                  class="fs-14 d-flex align-items-center justify-content-between"
                  style="font-weight: 600; color: #f77474; width: 40%"
                >
                  <!-- <img style="width: 1.875rem; height: 1.875rem" src="@/assets/images/statistics/error.svg" alt="" /> -->
                  <span
                    class="status-icon mt-1 status-icon-error"
                    style="
                      padding: 8px 15px;
                      width: 25px;
                      height: 25px;
                      background-size: 25px 25px;
                    "
                  ></span>
                  <div>
                    {{ $t("overview_static.customer_page.risky") }}
                  </div>
                </div>
                <div class="fs-14" style="font-weight: 600; width: 30%">
                  {{ risky_num }}
                </div>
              </div>
              <!-- 未知 -->
              <div
                class="w-100 d-flex justify-content-between align-items-center"
              >
                <div
                  class="fs-14 d-flex align-items-center justify-content-between"
                  style="font-weight: 600; color: #b6b7bc; width: 40%"
                >
                  <!-- <img style="width: 1.875rem; height: 1.875rem" src="@/assets/images/statistics/error.svg" alt="" /> -->
                  <span
                    class="status-icon mt-1 status-icon-unknown_"
                    style="
                      padding: 8px 15px;
                      width: 25px;
                      height: 25px;
                      background-size: 25px 25px;
                    "
                  ></span>
                  <div>
                    {{ $t("overview_static.customer_page.unknown") }}
                  </div>
                </div>
                <div class="fs-14" style="font-weight: 600; width: 30%">
                  {{ unknown_num }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-100 d-flex justify-content-around mt-2" style="height: 30%">
        <div
          style="
            width: 90%;
            height: 100%;
            border-radius: 20px;
            border: 2px solid rgba(198, 194, 194, 0.2);
            background: #1e2130;
          "
          class="mb-3 p-4 position-relative"
        >
          <div class="relative">
            <SelectTops
              :name="$t(currentSelect)"
              button-name=""
              v-model:currentSelect="currentSelect"
              :checkedList="checkedList"
              currentType="1"
              className="eventsList"
            ></SelectTops>
          </div>
          <div
              v-if="currentSelect === '设备事件'"
              class="d-flex flex-wrap mt-2"
              style="height: 90%"
            >
            <div
              class="w-100 d-flex flex-wrap align-content-start"
              style="height: 90%"
            >
              <div
                class="w-100 text-center"
                style="color: #909399; font-size: 23px; line-height: 230px"
                v-if="eventsList.length === 0"
              >
                {{ $t("base.no-data") }}
              </div>
              <div
                v-for="a in eventsList"
                :key="a.text"
                class="w-100 d-flex flex-wrap justify-content-between align-items-center"
              >
                <div
                  class="d-flex justify-content-between align-items-center"
                  style="width: 100%"
                >
                  <div
                    class="fs-14 d-flex align-items-center"
                    style="font-weight: 400; color: #ffffff"
                  >
                    <!-- <img style="width: 1.875rem; height: 1.875rem" :src="statusTypes[a.level]" alt="" /> -->
                    <span
                      style="
                        display: inline-block;
                        margin-top: 3px;
                        margin-right: 10px;
                        width: 25px;
                        height: 25px;
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                      "
                      :style="{
                        backgroundImage: `url(${statusTypes[a.level]})`,
                      }"
                    ></span>
                    <div class="ms-2">
                      {{ statusTexts[a.level] }}
                      <span style="font-size: 14px; font-weight: 400">{{
                        a.forDeviceList &&
                        a.forDeviceList[0] &&
                        a.forDeviceList[0].name.split("$")[0]
                      }}</span>
                    </div>
                  </div>
                  <div class="fs-14">
                    {{ moment(a.createdAt).format("YYYY-MM-DD HH:mm:ss") }}
                  </div>
                </div>
                <div class="fs-14 ms-2" style="padding-left: 1.875rem">
                  {{$t(`device_event_description['${a.description}']`)  }}
                </div>
              </div>
            </div>

          <div
              class="w-100 d-flex justify-content-end"
              v-if="eventsList.length"
            >
              <div
                v-if="currentSelect === '设备事件'"
                @click="$router.push('/iot/event-management')"
                style="cursor: pointer; color: #0096e3"
              >
                {{ $t("overview_static.common.details") }} >>
              </div>
              <div
                v-if="currentSelect === '服务请求'"
                @click="$router.push('/repair-request/list')"
                style="cursor: pointer; color: #0096e3"
              >
                {{ $t("overview_static.common.details") }} >>
              </div>
              <div
                v-if="currentSelect === '设备工单'"
                @click="$router.push('/work-order')"
                style="cursor: pointer; color: #0096e3"
              >
                {{ $t("overview_static.common.details") }} >>
              </div>
            </div>
          </div>
          <div v-else class="d-flex flex-wrap mt-2" style="height: 90%">
            <div
              class="d-flex flex-wrap w-100 align-content-start"
              style="height: 90%"
            >
              <div
                v-for="a in eventsList"
                :key="a.device_name"
                style="min-height: 45px"
                class="w-100 mt-1 d-flex align-items-center"
              >
                <div class="w-100 d-flex justify-content-between">
                  <div
                    class="fs-14 d-flex justify-content-between align-items-center w-100"
                    style="font-weight: 400; color: #ffffff"
                  >
                    <div class="d-flex w-70">
                      <div class="ms-2">
                        <span style="font-size: 14px; font-weight: 400">{{ a.device_name }}</span>
                      </div>
                      <div class="fs-14 d-flex">
                        <div>，</div>
                        <div
                          :class="
                            [
                              'text-success',
                              'text-danger',
                              'text-warning',
                              'text-anzhaung',
                              'text-danger',
                              'text-success',
                            ][a.type]
                          "
                        >
                          {{ $t(`device_work_order['${a.type_txt}']`)  }}
                        </div>
                      </div>
                    </div>
                    <div class="fs-14">
                      {{ moment(a.created_at).format("YYYY-MM-DD HH:mm:ss") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-100 d-flex justify-content-end">
              <div
                v-if="currentSelect === '设备事件'"
                @click="$router.push('/iot/event-management')"
                style="cursor: pointer; color: #0096e3"
              >
                {{ $t("overview_static.common.details") }} >>
              </div>
              <div
                v-if="currentSelect === '服务请求'"
                @click="$router.push('/repair-request/list')"
                style="cursor: pointer; color: #0096e3"
              >
                {{ $t("overview_static.common.details") }} >>
              </div>
              <div
                v-if="currentSelect === '设备工单'"
                @click="$router.push('/work-order')"
                style="cursor: pointer; color: #0096e3"
              >
                {{ $t("overview_static.common.details") }} >>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w-100 d-flex justify-content-around mt-2"
        style="height: 35%; min-height: 300px"
      >
        <div
          style="
            width: 90%;
            height: 100%;
            border-radius: 20px;
            border: 2px solid rgba(198, 194, 194, 0.2);
            background: #1e2130;
          "
          class="mb-3 p-4 position-relative"
        >
          <SelectTop
            :name="$t('overview_static.customer_page.energy_consumption_trend')"
            :button-name="deviceCurrentSelect"
            v-model:deviceCurrentSelect="deviceCurrentSelect"
            className="deviceList"
            currentType="2"
            :deviceCheckedList="deviceCheckedList"
          ></SelectTop>
          <div id="clientChart" style="width: 100%; height: 90%"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  energyYoyData,
  getEventsList,
  getRepairList,
  workOrderList,
} from "@/service";
import moment from "moment";
import { clientChart } from "@/utils/chart";
import { API_SVC_HOST, WO_TYPE } from "@/config/common";
import { instanceApi } from "@/service";
import Top_title_statistics from "@/components/common/Top_title_statistics.vue";
import _ from "lodash";
import SelectTop from "./SelectTopKehu.vue";
import SelectTops from "./SelectTopKehus.vue";
import qs from "qs";
import { SOCKET_SVC_HOST,IS_DEMO_PAPER_MAKING_CUSTOMER_ID } from "@/config/common.js";

export default {
  page: {
    title: "设备云图",
  },
  data() {
    return {
      WO_TYPE,
      currentSelect: "设备事件",
      deviceCurrentSelect: "",
      isRolling: false,
      pathType: "statisticsDashboard",
      language: "",
      timmer: null,
      timeData: "",
      yearData: "",
      weekData: "",
      fullscreen: false,
      instanceList: [],
      eventsList: [],
      statusTypes: {
        // 'HINT': require("@/assets/images/statistics/eventsheathy.svg"),
        // 'WARNING': require("@/assets/images/statistics/eventswarn.svg"),
        // 'ERROR': require("@/assets/images/statistics/eventserror.svg")
        NORMAL: require("@/assets/vsd420/remind.svg"),
        ERROR: require("@/assets/vsd420/error.svg"),
        WARNING: require("@/assets/vsd420/warning.svg"),
        UNKNOWN: require("@/assets/images/healthy-state/faulty_.svg"),
      },
      statusTexts: {
        HINT: this.$t("overview_dynamic.event_type_dict['提醒']"),
        WARNING: this.$t("overview_dynamic.event_type_dict['警告']"),
        ERROR: this.$t("overview_dynamic.event_type_dict['错误']"),
      },
      checkedList: [
        {
          name: this.$t('设备事件'),
          type: "设备事件",
          checked: true,
        },
        {
          name: this.$t('设备工单'),
          type: "设备工单",
          checked: false,
        },
        {
          name: this.$t('服务请求'),
          type: "服务请求",
          checked: false,
        },
      ],
      deviceCheckedList: [],
      // 在线或离线
      online_num: 0,
      offline_num: 0,
      //健康状态
      healthy_num: 0,
      abnormal_num: 0,
      risky_num: 0,
      unknown_num: 0,
      shadowIds: [],
      shadowIdsMeasure: {}, //关于所有测点状态
      shadowIdsMeasureStats: {}, //关于所有设备测点状态
      mockSourceIds: [],
      retryCount: 0,
    };
  },
  components: { SelectTop, Top_title_statistics, SelectTops },
  computed: {
    icon() {
      return this.fullscreen ? "ri-fullscreen-exit-line" : "ri-fullscreen-line";
    },
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    logoutUrl() {
      return _.trimEnd(_.trim(API_SVC_HOST, '"'), "/") + "/logout";
    },
    costumerId() {
      return (
        this.$route.query.id ||
        localStorage.getItem("statistics_id") ||
        JSON.parse(localStorage.getItem("user")).org.id ||
        ""
      );
    },
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    }
  },
  watch: {
    deviceCurrentSelect: {
      handler(val) {
        if (val) {
          this.deviceCheckedList.map((item) => {
            if (item.checked && val == item.type) {
              if (this.isPaperMaking) {  //造纸厂展示内容
                this.chartDemo()
              }else{
                this.getEnergyYoyData(item.id);
              }
            }
          });
        }
      },
      deep: true,
    },
    currentSelect: {
      handler(val) {
        switch (val) {
          case "设备事件":
            this.getEventsLists();
            break;
          case "设备工单":
            this.getWorkOrderList();
            break;
          case "服务请求":
            this.getRepairLists();
            break;
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.language = localStorage.getItem("language");
    if (this.$route.query.id || this.costumerId) {
      localStorage.setItem("statistics_id", (this.$route.query.id || this.costumerId));
      //造纸厂展示内容
      if (this.costumerId == IS_DEMO_PAPER_MAKING_CUSTOMER_ID || this.$route.query.id == IS_DEMO_PAPER_MAKING_CUSTOMER_ID) { 
        this.$store.commit( "equipManagement/setIsDemonstrationPaperMaking", true);
      }else{
        this.$store.commit( "equipManagement/setIsDemonstrationPaperMaking", false);
      }

    }
    // 获取设备列表数据
    this.getInstanceApi();
    // 推送数据
    this.initWebSocket();
  },
  beforeUnmount() {
    if (this.mockSourceIds.length) {
      this.$websocket.dispatch(
        "WEBSOCKET_UNREGISTER_MOCK_SOURCE",
        this.mockSourceIds
      );
      this.mockSourceIds = [];
    }
  },

  methods: {
    buildMockSourceFromDevice(device) {
      if (!device || String(device.product_type) !== "1" || !device.id) {
        return null;
      }
      const rawMeasurements = Array.isArray(device.measurements)
        ? device.measurements
        : device.attributes &&
          Array.isArray(device.attributes.measurements)
        ? device.attributes.measurements
        : [];
      const measurements = rawMeasurements
        .filter(
          (item) => item && item.key && (item.is_show === undefined || item.is_show)
        )
        .map((item) => ({
          key: item.key,
          name: item.name,
          full_name: item.full_name,
          unit: item.unit,
          operationThresholdLow: item.operationThresholdLow,
          operationThresholdHigh: item.operationThresholdHigh,
          standardThresholdLow: item.standardThresholdLow,
          standardThresholdHigh: item.standardThresholdHigh,
        }));
      return {
        shadowId: device.id,
        equipName: device.name || "",
        measurements,
      };
    },
    syncMockSourcesFromInstanceList() {
      const sourceMap = {};
      const appendSource = (device) => {
        const source = this.buildMockSourceFromDevice(device);
        if (!source) return;
        if (!sourceMap[source.shadowId]) {
          sourceMap[source.shadowId] = {
            shadowId: source.shadowId,
            equipName: source.equipName,
            measurements: [],
          };
        }
        const target = sourceMap[source.shadowId];
        const keyMap = {};
        target.measurements.forEach((item) => {
          if (item && item.key) keyMap[item.key] = true;
        });
        source.measurements.forEach((measurement) => {
          if (!measurement || !measurement.key || keyMap[measurement.key]) return;
          keyMap[measurement.key] = true;
          target.measurements.push(measurement);
        });
      };

      const walkNodes = (nodes) => {
        if (!Array.isArray(nodes) || !nodes.length) return;
        nodes.forEach((node) => {
          appendSource(node);
          if (Array.isArray(node.children) && node.children.length) {
            walkNodes(node.children);
          }
        });
      };

      walkNodes(this.instanceList);
      const sources = Object.values(sourceMap);
      if (this.mockSourceIds.length) {
        this.$websocket.dispatch(
          "WEBSOCKET_UNREGISTER_MOCK_SOURCE",
          this.mockSourceIds
        );
      }
      if (sources.length) {
        this.$websocket.dispatch("WEBSOCKET_REGISTER_MOCK_SOURCE", sources);
      }
      this.mockSourceIds = sources.map((item) => item.shadowId);
    },
    updateDeviceIotConnected(shadowId, connected = true) {
      if (!shadowId) return;
      const walkNodes = (nodes) => {
        if (!Array.isArray(nodes) || !nodes.length) return;
        nodes.forEach((node) => {
          if (String(node.product_type) === "1" && node.id === shadowId) {
            node.is_iot_connected = connected;
          }
          if (Array.isArray(node.children) && node.children.length) {
            walkNodes(node.children);
          }
        });
      };
      walkNodes(this.instanceList);
    },
    updateInstanceStatusSummary() {
      // 状态更新，设备状态赋值
      this.instanceList.map((instance) => {
        if (instance.product_type == "1") {
          //设备
          instance.stat = this.getTopStatusFun(instance.id);
        } else if (instance.product_type == "2") {
          //机组
          this.getChildrenStatus(instance.children);
        }
      });

      //获取机组状态（从子设备获得），未考虑机组测点
      this.instanceList.map((instance) => {
        if (instance.product_type == "2") {
          instance.stat = this.getTopChildrenStatus(instance.children);
        }
      });

      // 在线或离线
      const onlineCount = this.onLineNum(this.instanceList);
      this.online_num = onlineCount.count;
      this.offline_num = onlineCount.count1;

      //健康状态
      const healthCount = this.equStatNum(this.instanceList);
      this.healthy_num = healthCount.count;
      this.abnormal_num = healthCount.count1;
      this.risky_num = healthCount.count2;
      this.unknown_num = healthCount.count3;
    },
    chartDemo(){
        let last_data = ["2170666.67","2208000.00","2192666.67","2230000.00","2198666.67","2244666.67","2183333.33","2214666.67","2175333.33","2236000.00","2187333.33","2252666.67"]
        let current_data = ["1156000","1237333","1194667","502666.7"] ;
        clientChart({
          chartDom: document.getElementById("clientChart"),
          name1: this.$t("今年电耗"),
          name2: this.$t("去年电耗"),
          current_data: current_data,
          last_data: last_data,
          monthList: [
            this.$t("month.jan"),
            this.$t("month.feb"),
            this.$t("month.mar"),
            this.$t("month.apr"),
            this.$t("month.may"),
            this.$t("month.jun"),
            this.$t("month.jul"),
            this.$t("month.aug"),
            this.$t("month.sep"),
            this.$t("month.oct"),
            this.$t("month.nov"),
            this.$t("month.dec"),
          ],
        });
    },
    /* 获取设备列表数据 */
    getInstanceApi() {
      let params = { id: this.costumerId || null };
      instanceApi(params).then((res) => {
        if (res && res.payload && res.payload[0]) {
          this.instanceList = _.cloneDeep(res.payload);
          this.deviceCheckedList = _.cloneDeep(res.payload[0].children);
          this.deviceCheckedList &&
            this.deviceCheckedList.map((item) => {
              item["type"] = item.name;
              item["checked"] = false;
            });
          if (this.deviceCheckedList[0]) {
            this.deviceCheckedList[0].checked = true;
            this.deviceCurrentSelect = this.deviceCheckedList[0].type;
          }

          this.instanceList.map((item) => {
            /* 组装设备id列表 */
            if (item.product_type == 1) {
              //设备
              this.shadowIds.push(item.id);
              if (item.measurements && item.measurements.length) {
                let list = [];
                let stat = {};
                item.measurements.map((item) => {
                  if (item.is_show === undefined || item.is_show) {
                    list.push(item.key);
                    stat[item.key] = -1; //默认未知
                  }
                });

                //获取可展示测点列表
                this.shadowIdsMeasure[item.id] = list;
                //获取可展示设备测点对象
                this.shadowIdsMeasureStats[item.id] = stat;
              }
            }

            if (item.product_type == 2) {
              //机组
              item.is_iot_ready = this.getChildrenIOTReady(item.children);
            }
            if (item.children) {
              //每个设备都给一个默认的状态为未知-1，该状态会因为is_iot_ready开启和是否有测点数据展示
              //获取子设备
              this.shadowIdsBack(item);
              // 获取可展示测点列表
              this.measurementsBack(item);
              item.children.length &&
                item.children.map((child) => {
                  child["stat"] = -1;
                });
            }
            item["eIndex"] = 0;
            item["isRolling"] = false;
            item["stat"] = -1;
          });
          // console.log('-----shadowIds----',this.shadowIds)
          // console.log('-----measurementsBack----',this.shadowIdsMeasure)
          // console.log('-----measurementsBack----',this.shadowIdsMeasureStats)
          // 当前页面设备注册到模拟推送源
          this.syncMockSourcesFromInstanceList();
          // 初始化右侧统计
          this.updateInstanceStatusSummary();
          //获取事件列表
          this.getEventsLists();
        }
      });
    },
    /* 获取推送数据,处理 */
    initWebSocket() {
      const interval = setInterval(() => {
        if (this.retryCount > 10) {
          clearInterval(interval);
          this.retryCount = 0;
          return;
        }
        const stompClient = this.$websocket.getters.stompClient();
        if (stompClient != null && stompClient.connected) {
          clearInterval(interval);
          stompClient.subscribe("/topic/stream", (msg) => {
            if (msg && msg.body) {
              let websocketdata = Array.isArray(JSON.parse(msg.body))
                ? JSON.parse(msg.body)
                : [JSON.parse(msg.body)];
              if (this.$route.path == "/fullIndex") {
                this.getWebsocket(websocketdata);
              }
            }
          });
        } else {
          if (!localStorage.getItem("accessToken")) return;
          const _url =
            SOCKET_SVC_HOST +
            "/messaging/stomp?access_token=" +
            localStorage.getItem("accessToken");
          this.$websocket.dispatch("WEBSOCKET_INIT", _url);
        }
        this.retryCount++;
      }, 1000);
    },
    /* 处理数据匹配对应设备id 判断数状态 */
    getWebsocket(socdata) {
      if (socdata && socdata.length) {
        /* 匹配推送的对应设备id，按整批推送逐条更新 */
        socdata.forEach((singleSocData) => {
          if (!singleSocData || !singleSocData.shadowId) return;

          // 有推送即视为该设备在线，驱动IoT在线/离线统计
          this.updateDeviceIotConnected(singleSocData.shadowId, true);

          if (
            this.shadowIdsMeasureStats[singleSocData.shadowId] &&
            Array.isArray(singleSocData.report)
          ) {
            singleSocData.report.forEach((item) => {
              if (
                this.shadowIdsMeasureStats[singleSocData.shadowId][item.id] !==
                  undefined &&
                this.shadowIdsMeasureStats[singleSocData.shadowId][item.id] !== null
              ) {
                // 生成每台设备下可展示测点的状态
                this.shadowIdsMeasureStats[singleSocData.shadowId][item.id] =
                  item.stat;
              }
            });
          }
        });

        this.updateInstanceStatusSummary();
      }
    },
    /* 离线，在线设备统计 */
    onLineNum(tree) {
      let num = {
        count: 0, // 计数器，初始化为0
        count1: 0,
      };

      // 遍历数组中的每个元素
      for (let i = 0; i < tree.length; i++) {
        const currentNode = tree[i];
        if (currentNode.product_type == 1) {
          /* ---判断设备是否在线--- */
          if (currentNode.is_iot_ready && currentNode.is_iot_connected) {
            num.count++; //在线设备
          } else {
            num.count1++; //离线设备
          }
        }

        // 如果当前节点有子节点，并且子节点是数组，递归遍历子节点并更新计数器
        if (Array.isArray(currentNode.children)) {
          num.count += this.onLineNum(currentNode.children).count;
          num.count1 += this.onLineNum(currentNode.children).count1;
        }
      }

      // 返回最终的计数
      return num;
    },
    /**
     * 设备状态统计，未知（-1），健康（0），异常（1），危险（2）*/
    equStatNum(tree) {
      let num = {
        count: 0, // 计数器，初始化为0
        count1: 0,
        count2: 0,
        count3: 0,
      };

      // 遍历数组中的每个元素
      for (let i = 0; i < tree.length; i++) {
        const currentNode = tree[i];

        // 检查当前节点是否满足条件
        if (
          currentNode.is_iot_ready &&
          currentNode.stat !== undefined &&
          currentNode.stat !== null &&
          currentNode.product_type == 1
        ) {
          if (currentNode.stat == 0) {
            num.count++;
          } else if (currentNode.stat == 1) {
            num.count1++;
          } else if (currentNode.stat == 2) {
            num.count2++;
          } else {
            // 未知
            num.count3++;
          }
        }

        // 如果当前节点有子节点，并且子节点是数组，递归遍历子节点并更新计数器
        if (Array.isArray(currentNode.children)) {
          num.count += this.equStatNum(currentNode.children).count;
          num.count1 += this.equStatNum(currentNode.children).count1;
          num.count2 += this.equStatNum(currentNode.children).count2;
          num.count3 += this.equStatNum(currentNode.children).count3;
        }
      }

      // 返回最终的计数
      return num;
    },
    /* 根据机组的子设备is_iot_ready判断，机组的状态 */
    getChildrenIOTReady(data) {
      let status = false;
      if (data && data.length > 0) {
        data.map((item) => {
          if (item.is_iot_ready) {
            //子设备有一个开启iot_ready,机组设备为开启状态
            status = true;
          }
        });
      }
      return status;
    },
    /* 大于0的状态赋值给初始值为0健康状态，大于0的状态。异常1，危险2。进行赋值 */
    getTopChildrenStatus(data) {
      /* 统一默认设置为未知状态 */
      let status = -1;
      //得到数据我直接找出最大的一个状态
      let obj = { "-1": 0, 0: 0, 1: 0, 2: 0 };
      if (data && data.length > 0) {
        data.map((item) => {
          if (
            item.stat !== undefined &&
            item.stat !== null &&
            item.stat > status
          ) {
            obj[item.stat] += 1;
          }
        });
      }
      /* 异常(-1)<健康(0)<异常(1)<危险(2) */
      if (obj["0"] >= 1) {
        status = 0;
      }
      if (obj["1"] >= 1) {
        status = 1;
      }
      if (obj["2"] >= 1) {
        status = 2;
      }
      return status;
    },
    /* 获取当前已更新设备测点，比对。获得设备状态 */
    getTopStatusFun(id) {
      let status = -1;
      if (this.shadowIdsMeasureStats[id]) {
        let values = Object.values(this.shadowIdsMeasureStats[id]);
        if (values) {
          status = Math.max(...values);
        }
      }
      return status;
    },
    /* 子设备状态赋值 */
    getChildrenStatus(children) {
      if (children && children.length > 0) {
        children.map((item) => {
          item.stat = this.getTopStatusFun(item.id);
        });
      }
    },
    /* 状态赋值，格局stat状态值 */
    getStatObj(stat) {
      let result = {
        name: this.$t("overview_static.customer_page.healthy"),
        img: require("@/assets/images/statistics/normal.svg"),
        color: "#11cabe",
        icon: "health",
      };
      switch (parseInt(stat)) {
        case 0:
          result = {
            name: this.$t("overview_static.customer_page.healthy"),
            img: require("@/assets/images/statistics/normal.svg"),
            color: "#11cabe",
            icon: "health",
          };
          break;
        case 1:
          result = {
            name: this.$t("overview_static.customer_page.abnormal"),

            img: require("@/assets/images/statistics/warn.svg"),
            color: "#faad14",
            icon: "sub-health",
          };
          break;
        case 2:
          result = {
            name: this.$t("overview_static.customer_page.risky"),

            img: require("@/assets/images/statistics/error.svg"),
            color: "#f77474",
            icon: "error",
          };
          break;
        default:
          result = {
            name: this.$t("overview_static.customer_page.unknown"),

            img: require("@/assets/images/statistics/normal.svg"),
            color: "#b6b7bc",
            icon: "unknown_",
          };
          break;
      }

      return result;
    },
    //递归获取设备id列表
    shadowIdsBack(item) {
      if (item.children && item.children.length) {
        item.children.map((equip) => {
          if (equip.product_type == 1) {
            //设备
            this.shadowIds.push(equip.id);
          }
        });
      }
    },
    //递归获取设备可展示测点列表
    measurementsBack(item) {
      if (item.children && item.children.length) {
        item.children.map((equip) => {
          if (equip.product_type == 1 && equip.measurements.length) {
            //设备
            let relust = [];
            let stat = {};
            equip.measurements.map((item) => {
              if (item.is_show === undefined || item.is_show) {
                relust.push(item.key);
                stat[item.key] = -1; //默认未知
              }
            });
            this.shadowIdsMeasure[equip.id] = relust;
            this.shadowIdsMeasureStats[equip.id] = stat;
          }
        });
      }
    },
    getEnergyYoyData(id) {
      let params = {
        device_id: id,
      };
      energyYoyData(params).then((res) => {
        let current_data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        res.payload&&res.payload.current_data&&res.payload.current_data.map((item) => {
          current_data[moment(item.date).format("M") - 1] = Number(
            item.value
          ).toFixed(2);
        });
        let last_data = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        res.payload&&res.payload.last_data&&res.payload.last_data.map((item) => {
          last_data[moment(item.date).format("M") - 1] = Number(
            item.value
          ).toFixed(2);
        });

        clientChart({
          chartDom: document.getElementById("clientChart"),
          name1: this.$t("今年电耗"),
          name2: this.$t("去年电耗"),
          current_data: current_data,
          last_data: last_data,
          monthList: [
            this.$t("month.jan"),
            this.$t("month.feb"),
            this.$t("month.mar"),
            this.$t("month.apr"),
            this.$t("month.may"),
            this.$t("month.jun"),
            this.$t("month.jul"),
            this.$t("month.aug"),
            this.$t("month.sep"),
            this.$t("month.oct"),
            this.$t("month.nov"),
            this.$t("month.dec"),
          ],
        });
      });
    },
    getRepairLists() {
      this.eventsList = [];
      let params = {
        page: 1,
        page_size: 5,
        customer: this.$route.query.id,
      };
      getRepairList(params).then((res) => {
        this.eventsList = res.payload.results;
      });
    },
    getEventsLists() {
      this.eventsList = [];
      let params = {
        page: 1,
        page_size: 5,
        shadowId: this.shadowIds,
      };

      // this.instanceList.map(item => {
      //   params['shadowId'].push(item.id)
      // })
      params = qs.stringify(params, { arrayFormat: "repeat" });

      getEventsList(params).then((res) => {
        if (res.payload && res.payload.data.length > 5) {
          this.eventsList = res.payload.data.splice(0, 5);
        }
      });
    },
    getWorkOrderList() {
      this.eventsList = [];
      let params = {
        page: 1,
        page_size: 5,
        customer: this.$route.query.id,
      };
      workOrderList(params).then((res) => {
        this.eventsList = _.cloneDeep(res.payload.results);
      });
    },
    logout() {
      const form = document.getElementById("frm_logout");
      form.action = this.logoutUrl;
      form.submit();
      sessionStorage.setItem("is_logout", "true");
      setTimeout(() => {
        localStorage.clear();
      }, 2000);
    },
    skipPage(path) {
      this.pathType = path;
      this.$router.push("/" + path);
    },
    //全屏
    fullele() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        null
      );
    },

    //判断是否全屏
    isFullScreen() {
      return !!(document.webkitIsFullScreen || this.fullele());
    },
    //退出全屏
    exitFullscreen() {
      this.fullscreen = false;
      if (document.exitFullScreen) {
        document.exitFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    //全屏
    full(ele) {
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen();
      } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
      }
    },
    //切换是否全屏 全屏按钮要执行的方法
    toggleFullScreen() {
      if (this.isFullScreen()) {
        this.exitFullscreen();
      } else {
        this.fullscreen = true;
        this.full(document.getElementById("statistics")); //要设置全屏的元素
      }
    },
    changeLang(lang) {
      this.language = lang;
      localStorage.setItem("language", lang);
      // 设置i18n.locale 组件库会按照上面的配置使用对应的文案文件
      // this.$i18n.locale = lang;
      window.location.reload();
    },
    Refresh() {
      window.location.reload();
    },
    moment,
    toPath(deviceProfileName, id, index, item,subitem) {
      if (item.files && item.files["3d"] && item.files["3d"][0]) {
        localStorage.setItem("modelStr", item.files["3d"][0].url);
      }
      localStorage.setItem("equip_id", id);
      localStorage.setItem("deviceProfileName", deviceProfileName);
      if(subitem){
        this.$router.push(
        "/VSD420-OverAll?equip_id=" + id + "&sub_id=" + subitem
      );
      }else{
        this.$router.push(
        "/VSD420-OverAll?equip_id=" + id + "&index=" + (index + 1)
      );
      }
     
    },

    changeReverse(index, item, name, id, type) {
      if (name && id) {
        if (this.instanceList[index].id === id) {
          this.instanceList[index].name = name;
        }
        if (item.children && this.instanceList[index].isRolling) {
          item.children.map((a) => {
            if (a.id === id) {
              a.name = name;
            }
          });
        }
        if (type) {
          this.instanceList[index].isRolling = !item.isRolling;
        }
        this.shadowIds = [];
        this.shadowIdsMeasure = {}; //关于所有测点状态
        //修改设备名称后更新列表
        this.getInstanceApi();
      } else {
        if (item.children) {
          this.instanceList[index].isRolling = !item.isRolling;
        }
      }
    },
    eIndexChange(index, type) {
      switch (type) {
        case "1":
          if (
            this.instanceList[index].eIndex <
            this.instanceList[index].children.length - 1
          ) {
            this.instanceList[index].eIndex =
              this.instanceList[index].eIndex + 1;
          }
          break;
        case "2":
          if (this.instanceList[index].eIndex > 0) {
            this.instanceList[index].eIndex =
              this.instanceList[index].eIndex - 1;
          }
          break;
        default:
          break;
      }
    },
    imgChange(i, index) {
      this.instanceList[i].eIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.language {
  font-size: 12px;
  margin: 0 20px;
  display: flex;
  flex-flow: column;
  align-items: center;

  .lang {
    cursor: pointer;

    &.current {
      font-size: 16px;
    }
  }
}

.scroll-container::-webkit-scrollbar-track {
  background-color: #ffffff00;
}

.clickActive {
  border-radius: 1.4623rem;
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(255, 255, 255, 0.3) 100%
    ),
    rgba(111, 111, 111, 0.1);
  backdrop-filter: blur(5.3656rem);
}

.text-anzhaung {
  color: #27b5cb;
}
.scroll-box::-webkit-scrollbar {
  display: none; /* Chrome Safari */
  -ms-overflow-style: none; /* IE 10+ */
  scrollbar-width: none; /* Firefox */
}
</style>
